import * as tslib_1 from "tslib";
export class DuplicateNameConfirmModalComponent {
    constructor() {
        this.finishPromise = new Promise(() => {
        });
        this.resolveFinishPromise = () => { };
        this.isEdit = false;
    }
    show() {
        setTimeout(() => {
            this.confirmDuplicateNameModal.show();
        }, 200);
    }
    showAwait() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.finishPromise = new Promise(resolve => this.resolveFinishPromise = resolve);
            this.confirmDuplicateNameModal.show();
            yield this.finishPromise;
            return this.confirmed;
        });
    }
    editMode() {
        this.isEdit = true;
    }
    confirm() {
        this.confirmed = true;
        this.confirmDuplicateNameModal.hide();
        this.resolveFinishPromise();
    }
    discard() {
        this.confirmed = false;
        this.confirmDuplicateNameModal.hide();
        this.resolveFinishPromise();
    }
}
